import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { editAudiExclusiveEquipment } from '../../actions/app/audiExclusiveApp.actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'

const trackAudiExclusiveEquipmentEditButtonMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(editAudiExclusiveEquipment, action)) {
        const equipmentId = action.payload

        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc audi exclusive edit equipment',
            },
            attributes: {
                componentName: 'audi-exclusive-app',
                label: 'Audi Exclusive Edit',
                currentURL: window.location.href,
                targetURL: '',
                clickID: `edit-button-${equipmentId.replace(/\\/g, '.')}`,
                elementName: 'button',
                value: equipmentId,
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackAudiExclusiveEquipmentEditButtonMiddleware
